import { z } from 'zod';

import { emailSchema, strongPasswordSchema } from './common';

export const loginInputSchema = z.object({
  email: emailSchema,
  password: z.string().min(1, 'Password is required'),
});
export type LoginInput = z.infer<typeof loginInputSchema>;

export const refreshTokenInputSchema = z.object({
  refreshToken: z.string().min(1),
});
export type RefreshTokenInput = z.infer<typeof refreshTokenInputSchema>;

export const forgotPasswordInputSchema = z.object({
  email: emailSchema,
});
export type ForgotPasswordInput = z.infer<typeof forgotPasswordInputSchema>;

export const resetPasswordInputSchema = z.object({
  token: z.string().min(1),
  password: strongPasswordSchema,
});
export type ResetPasswordInput = z.infer<typeof resetPasswordInputSchema>;

export const acceptInvitationInputSchema = z.object({
  name: z.string().trim().min(1).max(120),
  password: strongPasswordSchema,
});
export type AcceptInvitationInput = z.infer<typeof acceptInvitationInputSchema>;
